import * as React from 'react';

const Search = ({
  fill = '#2A2A2A',
  width = '15',
  height = '14',
  ...otherProps
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...otherProps}
    width={width}
    height={height}
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.51095 10.2639C8.50538 11.1007 7.21246 11.604 5.80199 11.604C2.59764 11.604 0 9.00634 0 5.80199C0 2.59764 2.59764 0 5.80199 0C9.00634 0 11.604 2.59764 11.604 5.80199C11.604 7.1313 11.1569 8.35619 10.405 9.33453L14.1588 13.0883L13.2471 14L9.51095 10.2639ZM10.3154 5.80172C10.3154 8.29399 8.29497 10.3144 5.8027 10.3144C3.31043 10.3144 1.29004 8.29399 1.29004 5.80172C1.29004 3.30945 3.31043 1.28906 5.8027 1.28906C8.29497 1.28906 10.3154 3.30945 10.3154 5.80172Z"
      fill={fill}
    />
  </svg>
);

export default Search;
